import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getAPIBaseURL } from '../../services/helpers'
import { getData } from '../../services/request'

const AdminEmploymePayments = () => {
  const [payments, setPayments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const fetchPayments = async () => {
    setLoading(true)
    setError('')
    const url = `${getAPIBaseURL()}/employme/admin/payments`
    const res = await getData(url, {}, {})
    setLoading(false)
    if (res.error === '') {
      if (res.result?.status === 200) {
        const data = res.result.data?.data || res.result.data
        setPayments(Array.isArray(data) ? data : [])
      } else {
        setPayments([])
        setError(res.result?.data?.message || res.result?.data?.data || 'Unable to load payments')
      }
    } else {
      setError(res.result?.data?.message || res.result?.data?.data || 'Network error')
    }
  }

  useEffect(() => {
    fetchPayments()
  }, [])

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleString()
    } catch {
      return iso || '—'
    }
  }

  const formatCurrency = (amount) => {
    if (amount == null || amount === undefined) return '—'
    return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(amount)
  }

  const employerName = (p) => {
    const u = p.createdByUserId
    if (!u) return '—'
    return `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email || '—'
  }

  return (
    <section className="mx-auto max-w-6xl">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Employ Me Payments</h1>
          <p className="text-sm text-gray-600">Job listing payments (completed transactions)</p>
        </div>
        <Link
          to="/admin/app/employme"
          className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Back to overview
        </Link>
      </div>

      {error && (
        <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
      )}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        {loading ? (
          <div className="p-6 text-sm text-gray-500">Loading...</div>
        ) : payments.length === 0 ? (
          <div className="p-6 text-sm text-gray-500">No completed payments found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 font-semibold text-gray-700">Job Title</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Company</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Employer</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Amount</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Status</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Paid At</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {payments.map((p) => (
                  <tr key={p._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <Link to={`/admin/app/employme/payments/${p._id}`} className="font-medium text-gray-900 hover:underline">
                        {p.title || '—'}
                      </Link>
                    </td>
                    <td className="px-4 py-3 text-gray-700">{p.companyId?.name || '—'}</td>
                    <td className="px-4 py-3 text-gray-700">{employerName(p)}</td>
                    <td className="px-4 py-3 text-gray-700">{formatCurrency(p.paymentAmount)}</td>
                    <td className="px-4 py-3">
                      <span className="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">
                        {p.paymentStatus || 'completed'}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-gray-600">{formatDate(p.updatedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  )
}

export default AdminEmploymePayments
